<script lang="ts" setup>
import { v4 as uuid } from 'uuid'
import { getBannerImage } from './bannerImage'

interface Tag {
  id?: string
  name: string
}

interface BannerRecord {
  id?: string
  contentName?: string
  contentCoverUrl?: string
  backgroundImageUrl?: string
  showType?: number
  introduce?: string
  tagList?: Tag[]
  firstChapter?: { id?: string }
  authorInfo?: { author?: string }
}

const props = defineProps<{
  record: BannerRecord
  module: any
}>()

const coverId = uuid()

const tagWrapStyle = {
  height: '16px',
}
const tagItemStyle = {
  height: '16px',
  lineHeight: '16px',
  padding: '0 6px',
  fontSize: '10px',
  color: 'rgba(255, 255, 255, 0.8)',
  background: 'rgba(255, 255, 255, 0.15)',
  borderRadius: '8px',
}

const bgUrl = getBannerImage(props.record)
</script>

<template>
  <div class="banner-inline-card">
    <div class="banner-inline-card__bg" :style="{ backgroundImage: bgUrl ? `url(${bgUrl})` : 'none' }" />
    <div class="banner-inline-card__mask" />
    <div class="banner-inline-card__inner">
      <div class="banner-inline-card__cover">
        <BizBookCover
          :id="coverId"
          :src="bgUrl"
          :extra="{
            module_name: module.showName,
            module_id: module.id,
            module_type: module.columnType,
            author: record.authorInfo?.author,
            ...record,
          }"
        />
      </div>
      <div class="banner-inline-card__info">
        <div class="banner-inline-card__title">
          {{ record.contentName }}
        </div>
        <div class="banner-inline-card__desc">
          {{ record.introduce }}
        </div>
        <div v-if="record.tagList && record.tagList.length" class="banner-inline-card__tags">
          <BizShowTags
            :tags="record.tagList"
            :wrap-style="tagWrapStyle"
            :item-style="tagItemStyle"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.banner-inline-card {
  position: relative;
  width: 100%;
  height: 121px;
  border-radius: 8px;
  overflow: hidden;
}

.banner-inline-card__bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  filter: blur(4px);
  transform: scale(1.1);
}

.banner-inline-card__mask {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
}

.banner-inline-card__inner {
  position: relative;
  z-index: 1;
  height: 100%;
  display: flex;
  align-items: flex-start;
  padding: 10px;
  gap: 10px;
}

.banner-inline-card__cover {
  flex-shrink: 0;
  width: 76px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.banner-inline-card__info {
  flex: 1;
  min-width: 0;
  height: 101px;
  display: flex;
  flex-direction: column;
  color: #fff;
}

.banner-inline-card__title {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.banner-inline-card__desc {
  margin-top: 4px;
  font-size: 12px;
  line-height: 16px;
  color: rgba(255, 255, 255, 0.7);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.banner-inline-card__tags {
  margin-top: 8px;
  width: 100%;
}
</style>
